<!-- T001: Unified Dialog Template with header, content, and actions zones -->

<!-- Header Section: Title and icon display area -->
<div class="hx-dialog__header">
  <!-- Default header content from inputs (can be overridden by projection) -->
  @if (title() || icon()) {
    <div class="hx-dialog__header-row">
      @if (icon()) {
        <hx-icon
          class="hx-dialog__header-icon"
          [ngStyle]="{ color: iconColor() }"
          [svgIcon]="icon()"
          aria-hidden="true" />
      }
      @if (title()) {
        <h2
          class="hx-dialog__header-title"
          [id]="headerId()">
          {{ title() }}
        </h2>
      }
    </div>
  }
  <!-- Projected header content (overrides default for full customization) -->
  <ng-content select="[hxDialogHeader]" />
</div>

<!-- Content Section: Scrollable main content area -->
<div
  class="hx-dialog__content"
  [id]="contentId()">
  <div class="hx-dialog__content-scroll">
    <!-- Projected content -->
    <ng-content select="[hxDialogContent]" />
  </div>
</div>

<!-- Actions Section: Footer with buttons -->
<div class="hx-dialog__actions">
  <div class="hx-dialog__actions-container">
    <!-- Projected actions/buttons -->
    <ng-content select="[hxDialogActions]" />
  </div>
</div>

<!-- Fallback for generic content projection (backward compatibility with old pattern) -->
<ng-content />
